import React, { Component } from "react";
import "./TicketDetails.css";
import SideBySideLayout from "../2/Controls/SideBySideLayout";
import Icon from "../2/Controls/Icon";
import { FiPaperclip, FiSend } from "react-icons/fi";
import { convertMongoTime,getHelpDeskProrites,getHelpDeskStatuses } from "../../CommonFunctions";
import Input from "../2/Controls/Input";

// Define styles outside the component to be accessible everywhere
const infoRowStyle = {
  display: "flex",
  alignItems: "flex-start",
  marginBottom: "16px",
  fontSize: "14px",
  color: "#374151",
  lineHeight: "1.5"
};

const iconStyle = {
  width: "17px",
  height: "10px",
  marginRight: "12px",
  flexShrink: 0,
  color: "#6B7280"
};

class TicketDetails extends Component {
  constructor(props) {
    super(props);

this.state = {
  message: "",
  attachments: [],
  isUploading: false,
  uploadedAttachments: [],
  priority: "",  // Add this
  employees:[],
  status: "",    // Add this
   assignedTo: { EmployeeName: "", EmployeeId: "", EmployeeCode: "" },  // Add this
    showReassignModal: false  // Add this for modal control
};
    this.fileInputRef = React.createRef();
    this.chatMessagesRef = React.createRef();
  }

componentDidUpdate(prevProps, prevState) {
  // Sync state when ticket prop changes
  if (prevProps.ticket !== this.props.ticket && this.props.ticket) {
    // Get assigned employee from last message
    let assignedTo = { EmployeeName: "", EmployeeId: "", EmployeeCode: "" };
    const ticket = this.props.ticket;
    
    if (ticket.AssignTo) {
        assignedTo = ticket.AssignTo;
    }
    
    this.setState({
      priority: ticket.Priority || "Medium",
      status: ticket.Status || "Open",
      assignedTo: assignedTo
    });
  }
  
  if (this.chatMessagesRef.current) {
    this.chatMessagesRef.current.scrollTop = this.chatMessagesRef.current.scrollHeight;
  }
}



// Handle reassign employee
handleReassign = () => {
  this.setState({ showReassignModal: true });
};

// Handle employee selection for reassignment
handleEmployeeSelect = async (employeeKey) => {
  const selectedEmployee = this.state.employees.find(emp => emp.key === employeeKey);
  
  if (!selectedEmployee) return;
  
  const assignedToData = {
    EmployeeName: selectedEmployee.Name || selectedEmployee.EmployeeName || "",
    EmployeeId: selectedEmployee.EmployeeId || selectedEmployee.key || "",
    EmployeeCode: selectedEmployee.EmployeeCode || selectedEmployee.Code || ""
  };
  
  // Update state immediately
  this.setState({ 
    assignedTo: assignedToData,
    showReassignModal: false 
  });
  
  try {
    await this.sendAssignmentMessage(assignedToData);
    await this.props.updateHelpDeskTicket(this.props.ticket.key,{AssignTo:assignedToData})
  } catch (error) {
    console.error("Failed to reassign:", error);
    alert("Failed to reassign employee. Please try again.");
  }
};

// Send assignment message
sendAssignmentMessage = async (assignedToData) => {
  const { ticket } = this.props;
  
  // Get user email and key safely
  let userEmail = "";
  let userKey = "";
  if (this.props.user && this.props.user.user) {
    userEmail = this.props.user.user.EmailID || "";
    userKey = this.props.user.user.key || "";
  }
  
  // Create assignment message
  const assignmentMessage = `Ticket assigned to ${assignedToData.EmployeeName}`;
  
  // Create optimistic message for timeline
  const optimisticMessage = {
    ActionOn: new Date().toISOString(),
    Message: {
      Content: assignmentMessage,
      ActionBy: "admin",
      ActionByEmailId: userEmail,
      ActionByUserId: userKey,
      Attachments: [],
      IsRead: false,
      IsDeleiverd: false
    }
  };
  
  // Add optimistic message
  this.addMessageToTimeline(optimisticMessage);
  
  // Prepare payload
  const messagePayload = {
    Action: "AssignTo",
    TicketStatus: "In Progress",
    Message: assignmentMessage,
    IsRead: false,
    IsDeleiverd: false,
    ActionBy: "admin",
    ActionByEmailId: userEmail,
    ActionByUserId: userKey,
    AssignTo: assignedToData,
    Attachments: [],
    Remark: ""
  };
  
  try {
    const response = await this.props.sendHelpDeskTicketMessage(ticket.key, messagePayload);
    
    if (response && response.code === "0") {
      await this.refreshTicketData();
    } else {
      this.removeLastMessage();
      throw new Error( "Failed to assign employee");
    }
  } catch (error) {
    console.error("Failed to send assignment message:", error);
    this.removeLastMessage();
    throw error;
  }
};

// Cancel reassign modal
cancelReassign = () => {
  this.setState({ showReassignModal: false });
};


 renderAssignedToCard = () => {
  const { assignedTo, showReassignModal, employees } = this.state;
  
  return (
    <>
      <div className="ticket-details-card">
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          marginBottom: "12px"
        }}>
          <h3 style={{ margin: 0 }}>Assigned To</h3>
        
        </div>
        
        {assignedTo.EmployeeName ? (
          <div style={infoRowStyle}>
            <div style={iconStyle}>
              <Icon type="user" />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "500" }}>{assignedTo.EmployeeName}</div>
              {assignedTo.EmployeeCode && (
                <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "4px" }}>
                  Code: {assignedTo.EmployeeCode}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div style={{ 
            ...infoRowStyle, 
            color: "#9CA3AF", 
            fontStyle: "italic" 
          }}>
            <div style={iconStyle}>
              <Icon type="user" />
            </div>
            <div>Not assigned</div>
          </div>
        )}
          <button
            onClick={this.handleReassign}
            style={{
              padding: "4px 12px",
              fontSize: "12px",
              backgroundColor: "#3B82F6",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Reassign
          </button>
      </div>

      {/* Reassign Modal */}
      {showReassignModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "24px",
            width: "400px",
            maxWidth: "90%"
          }}>
            <h3 style={{ margin: "0 0 16px 0" }}>Reassign Ticket</h3>
            <select
              onChange={(e) => this.handleEmployeeSelect(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                marginBottom: "16px",
                border: "1px solid #D1D5DB",
                borderRadius: "4px"
              }}
            >
              <option value="">Select employee...</option>
              {employees.map(emp => (
                <option key={emp.key} value={emp.key}>
                  {emp.Name || emp.EmployeeName || emp.FullName} - {emp.EmployeeCode || emp.Code}
                </option>
              ))}
            </select>
            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
              <button
                onClick={this.cancelReassign}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#9CA3AF",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Handle priority change
handlePriorityChange = async (value) => {
  const newPriority = value;
  this.setState({ priority: newPriority });
  
  try {
       const message = `Ticket priority changed to ${newPriority}.`;
  
  // Create optimistic message for timeline
  const optimisticMessage = {
    ActionOn: new Date().toISOString(),
    Message: {
      Content: message,
      ActionBy: "admin",
      ActionByEmailId:this.props.user.user.EmailID || "",
      ActionByUserId: this.props.user.user.key || "",
      Attachments: [],
      IsRead: false,
      IsDeleiverd: false
    }
  };

   const messagePayload = {
    Action: "PriorityChange",
    TicketStatus:this.state.status,
    Message: message,
    IsRead: false,
    IsDeleiverd: false,
    ActionBy: "admin",
    ActionByEmailId: this.props.user.user.EmailID || "",
    ActionByUserId: this.props.user.user.key || "",
    AssignTo:{},
    Attachments: [],
    Remark: ""
  };
  
     await this.addMessageToTimeline(optimisticMessage);
      const response = await this.props.sendHelpDeskTicketMessage(this.props.ticket.key, messagePayload);
    
    if (response && response.code === "0") {
          await this.props.updateHelpDeskTicket(this.props.ticket.key,{Priority: newPriority});
      await this.refreshTicketData();
    } else {
      this.removeLastMessage();
      throw new Error( "Failed to update priority");
    }

   
  } catch (error) {
    console.error("Failed to update priority:", error);
    this.setState({ priority: this.props.ticket.Priority});
  }
};

// Handle status change
handleStatusChange = async (value) => {
  const newStatus = value;
  this.setState({ status: newStatus });
  
  try {
      const message = `Ticket status changed to ${newStatus}`;
  
  // Create optimistic message for timeline
  const optimisticMessage = {
    ActionOn: new Date().toISOString(),
    Message: {
      Content: message,
      ActionBy: "admin",
      ActionByEmailId:this.props.user.user.EmailID || "",
      ActionByUserId: this.props.user.user.key || "",
      Attachments: [],
      IsRead: false,
      IsDeleiverd: false
    }
  };

   const messagePayload = {
    Action: "StatusChange",
  TicketStatus:this.state.status,
    Message: message,
    IsRead: false,
    IsDeleiverd: false,
    ActionBy: "admin",
    ActionByEmailId: this.props.user.user.EmailID || "",
    ActionByUserId: this.props.user.user.key || "",
    AssignTo:{},
    Attachments: [],
    Remark: ""
  };
  
     await this.addMessageToTimeline(optimisticMessage);
      const response = await this.props.sendHelpDeskTicketMessage(this.props.ticket.key, messagePayload);
    
    if (response && response.code === "0") {
         await this.props.updateHelpDeskTicket(this.props.ticket.key,{Status: newStatus});
      await this.refreshTicketData();
    } else {
      this.removeLastMessage();
      throw new Error( "Failed to update status");
    }
   
  } catch (error) {
    console.error("Failed to update status:", error);
    this.setState({ status: this.props.ticket.Status || "Open" });
  }
};

 componentDidMount() {
  const { ticket } = this.props;
  const employeeList = this.props.config.ActiveEmployees;
  
  // Get assigned employee from ticket if exists in the last message
  let assignedTo = { EmployeeName: "", EmployeeId: "", EmployeeCode: "" };
  
  if (ticket.AssignTo) {
      assignedTo = ticket.AssignTo;
 
  }
  
  this.setState({
    employees: employeeList,
    assignedTo: assignedTo
  });
  
  if (ticket) {
    this.setState({
      priority: ticket.Priority || "Medium",
      status: ticket.Status || "Open"
    });
  }
}
  // Upload multiple attachments using the existing uploadFile function
  uploadAttachments = async (attachments) => {
    const uploadedFiles = [];
    
    for (const attachment of attachments) {
      try {
        this.setState({ isUploading: true });
        
        // Directly call the imported uploadFile function
        const result = await this.props.uploadFile(attachment.file, 'helpdesk');
        
        if (result && result.success) {
          uploadedFiles.push({
            fileName: attachment.name,
            fileUrl: result.fileUrl,
            fileType: attachment.type,
          });
        }
      } catch (error) {
        console.error("Failed to upload " + attachment.name + ":", error);
      }
    }
    
    this.setState({ isUploading: false });
    return uploadedFiles;
  };

  // Method to add message to timeline without waiting for API
  addMessageToTimeline = (newMessage) => {
    console.log("391 addMessageToTimeline");
    const currentTicket = this.props.ticket;
    const currentTimeline = Object.prototype.hasOwnProperty.call(currentTicket, "TimeLine") ? currentTicket.TimeLine : [];
    const updatedTimeline = [...currentTimeline, newMessage];
    
    // Create updated ticket object
    const updatedTicket = {
      ...currentTicket,
      TimeLine: updatedTimeline
    };
    
    // Update the ticket in parent component
    if (Object.prototype.hasOwnProperty.call(this.props, "onTicketUpdate")) {
      this.props.onTicketUpdate(updatedTicket);
    } else {
      // If no parent callback, directly modify the prop (not recommended but works in some cases)
      currentTicket.TimeLine = updatedTimeline;
      this.forceUpdate();
    }
  };

  // Method to remove the last message (for error handling)
  removeLastMessage = () => {
    const currentTicket = this.props.ticket;
    const currentTimeline = Object.prototype.hasOwnProperty.call(currentTicket, "TimeLine") ? currentTicket.TimeLine : [];
    const updatedTimeline = currentTimeline.slice(0, -1);
    
    const updatedTicket = {
      ...currentTicket,
      TimeLine: updatedTimeline
    };
    
    if (Object.prototype.hasOwnProperty.call(this.props, "onTicketUpdate")) {
      this.props.onTicketUpdate(updatedTicket);
    } else {
      currentTicket.TimeLine = updatedTimeline;
      this.forceUpdate();
    }
  };

  handleSend = async () => {
    const { message, attachments } = this.state;
    const { ticket } = this.props;

    if (!message.trim() && attachments.length === 0) return;

    // Get user email and key safely
    let userEmail = "";
    let userKey = "";
    if (Object.prototype.hasOwnProperty.call(this.props, "user") && 
        this.props.user && 
        Object.prototype.hasOwnProperty.call(this.props.user, "user")) {
      userEmail = Object.prototype.hasOwnProperty.call(this.props.user.user, "EmailID") ? this.props.user.user.EmailID : "";
      userKey = Object.prototype.hasOwnProperty.call(this.props.user.user, "key") ? this.props.user.user.key : "";
    }

    // Create optimistic message for immediate display


    try {
      let uploadedFiles = [];
      
      if (attachments.length > 0) {
        uploadedFiles = await this.uploadAttachments(attachments);
        
        // Clean up preview URLs
        attachments.forEach(function(attachment) {
          if (Object.prototype.hasOwnProperty.call(attachment, "preview") && attachment.preview) {
            URL.revokeObjectURL(attachment.preview);
          }
        });
      }

          const optimisticMessage = {
      ActionOn: new Date().toISOString(),
      Message: {
        Content: message.trim(),
        ActionBy: "admin",
        ActionByEmailId: userEmail,
        ActionByUserId: userKey,
        Attachments:uploadedFiles.map(function(file) {
          return {
            FileName: file.fileName,
            Url: file.fileUrl,
            Type: file.fileType
          };
        }),
        IsRead: false,
        IsDeleiverd: false
      }
    };

    // Add optimistic message to timeline immediately
    this.addMessageToTimeline(optimisticMessage);

      // Prepare the data for ADMIN user
      const messagePayload = {
        Action: "Message",
        TicketStatus: Object.prototype.hasOwnProperty.call(ticket, "Status") ? ticket.Status : "",
        Message: message.trim(),
        IsRead: false,
        IsDeleiverd: false,
        ActionBy: "admin",
        ActionByEmailId: userEmail,
        ActionByUserId: userKey,
        AssignTo: this.state.assignedTo,
        Attachments: uploadedFiles.map(function(file) {
          return {
            FileName: file.fileName,
            Url: file.fileUrl,
            Type: file.fileType
          };
        }),
        Remark: ""
      };

      console.log("Admin Sending Message Payload:", messagePayload);
      
      // Call your API function
      const response = await this.props.sendHelpDeskTicketMessage(ticket.key, messagePayload);
      
      if (response && Object.prototype.hasOwnProperty.call(response, "code") && response.code === "0") {
        // Clear the form
        this.setState({
          message: "",
          attachments: [],
          uploadedAttachments: []
        });
        
        // Refresh ticket data to get the real message from server
        await this.refreshTicketData();
        
      } else {
        // Remove optimistic message if API call failed
        this.removeLastMessage();
        var errorMessage = (response && Object.prototype.hasOwnProperty.call(response, "message")) ? response.message : "Failed to send message";
        throw new Error(errorMessage);
      }
      
    } catch (error) {
      console.error("Failed to send admin message:", error);
      // Remove optimistic message on error
      this.removeLastMessage();
      alert(Object.prototype.hasOwnProperty.call(error, "message") ? error.message : "Failed to send message. Please try again.");
    }
  };

  // Method to refresh ticket data from server
  refreshTicketData = async () => {
    const { ticket } = this.props;
    const ticketKey = Object.prototype.hasOwnProperty.call(ticket, "key") ? ticket.key : null;
    
    if (!ticketKey) return;
    
    // Try to use getTicketDetails if provided
    if (Object.prototype.hasOwnProperty.call(this.props, "getTicketDetails") && this.props.getTicketDetails) {
      try {
        const response = await this.props.getTicketDetails(ticketKey);
        if (response && 
            Object.prototype.hasOwnProperty.call(response, "code") && 
            response.code === "0" && 
            Object.prototype.hasOwnProperty.call(response, "data") && 
            response.data) {
          if (Object.prototype.hasOwnProperty.call(this.props, "onTicketUpdate")) {
            this.props.onTicketUpdate(response.data);
          }
        }
      } catch (error) {
        console.error("Failed to refresh ticket:", error);
      }
    } 
    // Alternative: Use the existing getHelpDeskTicket if available
    else if (Object.prototype.hasOwnProperty.call(this.props, "getHelpDeskTicket") && this.props.getHelpDeskTicket) {
      try {
        const response = await this.props.getHelpDeskTicket(ticketKey);
        if (response && 
            Object.prototype.hasOwnProperty.call(response, "code") && 
            response.code === "0" && 
            Object.prototype.hasOwnProperty.call(response, "data") && 
            response.data) {
          if (Object.prototype.hasOwnProperty.call(this.props, "onTicketUpdate")) {
            this.props.onTicketUpdate(response.data);
          }
        }
      } catch (error) {
        console.error("Failed to refresh ticket:", error);
      }
    }
  };

  handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map((file) => ({
      file: file,
      name: file.name,
      type: file.type,
      size: file.size,
      preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null
    }));
    
    this.setState((prevState) => ({
      attachments: [...prevState.attachments, ...newAttachments]
    }));
  };

  handleRemoveAttachment = (index) => {
    this.setState((prevState) => {
      const newAttachments = [...prevState.attachments];
      if (newAttachments[index].preview) {
        URL.revokeObjectURL(newAttachments[index].preview);
      }
      newAttachments.splice(index, 1);
      return { attachments: newAttachments };
    });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.handleSend();
    }
  };

  formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: 'short'
    });
  };

renderAttachmentPreview = () => {
    const { attachments, isUploading } = this.state;
    if (attachments.length === 0) return null;

    console.log("attachments", attachments);
    return (
      <div className="attachment-previews">
        {attachments.map((attachment, index) => (
          <div key={index} className="attachment-preview-item">
            <div className="file-preview">
              <Icon type="file" />
              <span>{attachment.name}</span>
            </div>
            <button 
              className="remove-attachment"
              onClick={() => this.handleRemoveAttachment(index)}
              disabled={isUploading}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    );
  };

  renderMessage = (item, index) => {
    // Handle both nested and flat message structures
    let msg = Object.prototype.hasOwnProperty.call(item, "Message") ? item.Message : item;
    let actionOn = Object.prototype.hasOwnProperty.call(item, "ActionOn") ? item.ActionOn : 
                   (Object.prototype.hasOwnProperty.call(msg, "ActionOn") ? msg.ActionOn : "");
    let content = Object.prototype.hasOwnProperty.call(msg, "Content") ? msg.Content : 
                  (Object.prototype.hasOwnProperty.call(msg, "Message") ? msg.Message : "");
    let attachments = Object.prototype.hasOwnProperty.call(msg, "Attachments") ? msg.Attachments : [];
    let actionBy = Object.prototype.hasOwnProperty.call(msg, "ActionBy") ? msg.ActionBy : "";
    
    const isUser = actionBy === "user";
    const isAdmin = actionBy === "admin";
    const sender = isUser ? "Customer" : "Support";

    return (
      <div key={index} className={`message-row ${isUser ? 'user-message' : 'admin-message'}`}>
        <div className="message-bubble">
          <div className="message-sender">{sender}</div>
          <div className="message-text">{content}</div>
          
          {attachments.length > 0 && (
            <div className="message-attachments">
              {attachments.map((file, fileIndex) => (
                <a 
                  key={fileIndex}
                  href={Object.prototype.hasOwnProperty.call(file, "Url") ? file.Url : "#"} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="message-attachment"
                >
                  {Object.prototype.hasOwnProperty.call(file, "FileName") ? file.FileName : "Attachment"}
                </a>
              ))}
            </div>
          )}
          
          <div className="message-time">{this.formatDate(actionOn)}</div>
        </div>
      </div>
    );
  };

render() {
  const { ticket } = this.props;
  const { message, isUploading } = this.state;

  const customer = (ticket && Object.prototype.hasOwnProperty.call(ticket, "Customer")) ? ticket.Customer : {};
  const products = (ticket && Object.prototype.hasOwnProperty.call(ticket, "Products")) ? ticket.Products : [];
  const timeline = (ticket && Object.prototype.hasOwnProperty.call(ticket, "TimeLine")) ? ticket.TimeLine : [];
  const order = (ticket && Object.prototype.hasOwnProperty.call(ticket, "Order")) ? ticket.Order : null;

  const leftSideContent = () => {
    const ticketNumber = (ticket && Object.prototype.hasOwnProperty.call(ticket, "TicketNumber")) ? ticket.TicketNumber : "";
    const ticketStatus = (ticket && Object.prototype.hasOwnProperty.call(ticket, "Status")) ? ticket.Status : "";

    return (
      <div className="chat-container" style={{ height: '100%' }}>
        <div className="chat-messages" ref={this.chatMessagesRef} style={{ flex: 1 }}>
          {timeline.length === 0 ? (
            <div className="no-messages">No messages yet</div>
          ) : (
            timeline.map((item, index) => this.renderMessage(item, index))
          )}
        </div>

        <div className="chat-footer" style={{ flexShrink: 0 }}>
          {this.renderAttachmentPreview()}
          
          <div className="chat-input-wrapper">
            <button 
              className="attach-button"
              onClick={() => this.fileInputRef.current && this.fileInputRef.current.click()}
              disabled={isUploading}
            >
              <FiPaperclip size={20} color="#6b7280" />
            </button>
            
            <input
              type="file"
              ref={this.fileInputRef}
              style={{ display: 'none' }}
              multiple
              onChange={this.handleFileSelect}
              accept="image/*,application/pdf,.doc,.docx,.txt"
            />

            <textarea
              className="chat-textarea"
              placeholder="Type your message..."
              value={message}
              onChange={(e) => this.setState({ message: e.target.value })}
              onKeyPress={this.handleKeyPress}
              rows={1}
            />

            <button 
              className="send-button"
              onClick={this.handleSend}
              disabled={(!message.trim() && this.state.attachments.length === 0) || this.state.isUploading}
            >
              <FiSend size={20} />
            </button>
          </div>
        </div>
      </div>
    );
  };

 const renderHeader = () => {
  return (
    <div style={{ padding: "0 5px", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
          <span style={{ fontWeight: "bold", color: "black", fontSize: "16px" }}>
            {ticket.TicketNumber}
          </span>
          <span style={{ color: "#999" }}>•</span>
          <span>{ticket.Status}</span>
          <span style={{ color: "#999" }}>
            {convertMongoTime(ticket.updatedAt, { showRelative: true })}
          </span>
        </div>
        <div style={{ fontWeight: "bold", color: "black", marginTop: "4px" }}>
          {ticket.Type}
        </div>
      </div>
      <span  onClick={this.props.onClose}>
      <Icon 
        type="remove" 
      />
      </span>
    </div>
  );
};
  const rightSideContent = () => {
    const primaryAddress = (customer && Object.prototype.hasOwnProperty.call(customer, "Addresses") && customer.Addresses && customer.Addresses.length > 0) ? customer.Addresses[0] : null;
    
    const formatAddress = () => {
      if (!primaryAddress) return "-";
      const parts = [];
      if (Object.prototype.hasOwnProperty.call(primaryAddress, "Address1") && primaryAddress.Address1) parts.push(primaryAddress.Address1);
      if (Object.prototype.hasOwnProperty.call(primaryAddress, "Address2") && primaryAddress.Address2) parts.push(primaryAddress.Address2);
      if (Object.prototype.hasOwnProperty.call(primaryAddress, "City") && primaryAddress.City) parts.push(primaryAddress.City);
      if (Object.prototype.hasOwnProperty.call(primaryAddress, "State") && primaryAddress.State) parts.push(primaryAddress.State);
      if (Object.prototype.hasOwnProperty.call(primaryAddress, "PostalCode") && primaryAddress.PostalCode) parts.push(primaryAddress.PostalCode);
      return parts.length > 0 ? parts.join(", ") : "-";
    };

    const customerName = ((Object.prototype.hasOwnProperty.call(customer, "FirstName") ? customer.FirstName : "") || "") + " " + ((Object.prototype.hasOwnProperty.call(customer, "LastName") ? customer.LastName : "") || "");
    const finalCustomerName = customerName.trim() || "-";
    const phoneNumber = (Object.prototype.hasOwnProperty.call(customer, "PhoneNo") ? customer.PhoneNo : "") || "-";
    const email = (Object.prototype.hasOwnProperty.call(customer, "EmailID") ? customer.EmailID : "") || "-";
    const address = formatAddress();
    const orderNumber = (order && Object.prototype.hasOwnProperty.call(order, "TransactionNo") ? order.TransactionNo : "") || "-";

    const handlePriorityChange = async (e) => {
      const newPriority = e.target.value;
      try {
        if (this.props.updateTicketPriority) {
          await this.props.updateTicketPriority(ticket.key, newPriority);
          await this.refreshTicketData();
        }
      } catch (error) {
        console.error("Failed to update priority:", error);
      }
    };

    const sectionTitleStyle = {
      margin: "16px 0 12px 0",
      fontSize: "16px",
      fontWeight: "600",
      color: "#111827",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    };

    const productItemStyle = {
      padding: "8px 0",
      borderBottom: "1px solid #f0f0f0",
      fontSize: "13px",
      color: "#374151"
    };

    const productNameStyle = {
      fontWeight: "500",
      marginBottom: "4px"
    };

    const productSkuStyle = {
      fontSize: "11px",
      color: "#6B7280"
    };

    const currentPriority = (ticket && Object.prototype.hasOwnProperty.call(ticket, "Priority") ? ticket.Priority : "") || "Medium";
    const currentStatus = (ticket && Object.prototype.hasOwnProperty.call(ticket, "Status") ? ticket.Status : "") || "Open";

    return (
      <div className="ticket-sidebar custom-scrollable" style={{ 
        height: '100%', 
        overflowY: 'auto',
        padding: '20px'
      }}>
        {/* Priority and Status */}
        <div style={{ display: 'flex', gap: '16px'}}>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px", display: "block" }}>
              Priority
            </label>
            <Input
              type="select"
              value={this.state.priority}
              onChange={this.handlePriorityChange}
            >
              {getHelpDeskProrites.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px", display: "block" }}>
              Status
            </label>
            <Input
              type="select"
              value={this.state.status}
              onChange={this.handleStatusChange}
            >
              {getHelpDeskStatuses.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </div>
        </div>
        
        {this.renderAssignedToCard()}
        
        <div className="ticket-details-card">
          <h3>Customer Details</h3>

          <div style={infoRowStyle}>
            <div style={iconStyle}><Icon type="user" /></div>
            <div style={{ flex: 1, fontWeight: "500" }}>{finalCustomerName}</div>
          </div>

          <div style={infoRowStyle}>
            <div style={iconStyle}><Icon type="smartphone" /></div>
            <div style={{ flex: 1 }}>{phoneNumber}</div>
          </div>

          <div style={infoRowStyle}>
            <div style={iconStyle}><Icon type="email" /></div>
            <div style={{ flex: 1 }}>{email}</div>
          </div>

          <div style={infoRowStyle}>
            <div style={iconStyle}><Icon type="location" /></div>
            <div style={{ flex: 1, lineHeight: "1.5" }}>{address}</div>
          </div>
        </div>

        {products && products.length > 0 && (
          <div className="ticket-details-card">
            <h3>Products ({products.length})</h3>

            <div style={infoRowStyle}>
              {products.map((product, index) => (
                <div key={index} style={productItemStyle}>
                  <div style={productNameStyle}>
                    {(Object.prototype.hasOwnProperty.call(product, "ProductName") ? product.ProductName : "") || "Unnamed Product"}
                  </div>
                  <div style={productSkuStyle}>
                    SKU: {(Object.prototype.hasOwnProperty.call(product, "SKU") ? product.SKU : "") || "-"}
                  </div>
                  {(Object.prototype.hasOwnProperty.call(product, "Barcode") && product.Barcode && product.Barcode !== "-") && (
                    <div style={productSkuStyle}>
                      Barcode: {product.Barcode}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {orderNumber !== "-" && (
              <div style={{ ...infoRowStyle, marginTop: "8px" }}>
                <div style={{ flex: 1 }}><strong>Order No:</strong> {orderNumber}</div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="header-margin" >
      <div style={{ 
        padding: "10px",
        display: "flex", 
        flexDirection: "column", 
        height: "100vh",
        overflow: "hidden"
      }}>
        {/* Simple header */}
        <div style={{
          padding: "10px 16px",
          borderBottom: "1px solid #eee",
          flexShrink: 0,
          background: "white",
                  borderTopLeftRadius: "12px", // Add this
        borderTopRightRadius: "12px", // Add this

        }}>
          {renderHeader()}
        </div>
        
        {/* Main content area */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          flex: 1,
          overflow: 'hidden'
        }}>
          {/* Left Side - 65% */}
          <div style={{
            flex: '0 0 65%',
            maxWidth: '65%',
            width: '65%',
            height: '100%',
            overflow: 'hidden',
              borderBottomLeftRadius: "12px",
          }}>
            {leftSideContent()}
          </div>
          
          {/* Right Side - 35% */}
          <div style={{
            flex: '0 0 35%',
            maxWidth: '35%',
            width: '35%',
            height: '100%',
            overflow: 'hidden',
              borderBottomRightRadius: "12px",
          }}>
            {rightSideContent()}
          </div>
        </div>
      </div>
    </div>
  );
}
}

export default TicketDetails;